import { Injectable } from "@angular/core"
import { OkxWebsocketClient } from "../../../market"
import { Observable } from "rxjs"
import { Deal, OrderSide } from "../../../model/trade"
import { isWsDataOrderEvent, WsDataEvent } from "libs/okx-api/src"
import { parseFloatSafe, parseIntSafe } from "src/app/core/func"
import { BoardId } from "src/app/core/model/common"

@Injectable({
  providedIn: 'root'
})
export class OkxDealHandler {

  listen(ws: OkxWebsocketClient) {
    return new Observable<{deal: Deal}>(subscriber => {
      const f = (data: WsDataEvent) => {
        if (isWsDataOrderEvent(data)) {
          data.data.forEach(row => {
            if (row.fillSz && parseFloatSafe(row.fillSz) > 0) {
              const deal: Deal = {
                timestamp: parseIntSafe(row.uTime),
                market: 'okx',
                board: row.instType.toLowerCase() as BoardId,
                symbol: row.instId,
                price: row.fillPx,
                quantity: row.fillSz,
                volume: row.fillNotionalUsd,
                fee: row.fee,
                feeAsset: row.feeCcy,
                side: row.side === 'buy' ? OrderSide.buy : OrderSide.sell,
                dealId: row.tradeId,
                orderId: row.ordId,
                clientOrderId: row.clOrdId,
              }
              subscriber.next({deal})
            }
          })
        }
      }

      ws.on('update', f)
      return () => ws.off('update', f)
    })
  }

}
